import { AdSlotStatus } from 'sdk/types';
export default function isThereFeaturedVideoOrUap() {
    var _a;
    return (((_a = window.SilverSurferSDK.getContext().slots) === null || _a === void 0 ? void 0 : _a['uap']) === AdSlotStatus.LOADED ||
        document.querySelector('.article-featured-video') != null);
}
